import Image from 'next/image'
import { ChangeEvent, useEffect, useState } from 'react'
import styled from 'styled-components'

import useDebounce from '@/app/hooks/useDebounce'
import { colors, spaces } from '@/config/global-parameters'

interface IFilterInput {
  className?: string
  placeholder?: string
  onChange: (value: string) => void
  debounceTimeMs?: number
}

const FilterInput = ({ className, debounceTimeMs = 500, onChange, placeholder }: IFilterInput) => {
  const [value, setValue] = useState<string>('')
  const debouncedValue = useDebounce(value, debounceTimeMs)

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
  }
  const SearchIcon = (
    <ImageBox value={value}>
      <Image
        alt="Search icon"
        height={16}
        src="/icons/search.svg"
        width={16}
      />
    </ImageBox>
  )

  useEffect(() => {
    onChange(debouncedValue)
  }, [debouncedValue, onChange])

  return (
    <Wrapper className={className}>
      {SearchIcon}
      <InputStyled
        onChange={handleInputChange}
        placeholder={placeholder}
        type="text"
        value={value}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div``

const ImageBox = styled.div<{ value: string | undefined }>`
  position: absolute;
  padding-left: ${spaces.s};
  padding-top: 5px;
  display: none;
  @media (max-width: ${spaces.tabletBreakpoint}) {
    display: block;
    ${({ value }) => value && { display: 'none' }}
  }
`

export const InputStyled = styled.input`
  height: 27px;
  width: 100%;
  border: 1px solid ${colors.colorGrey15};
  background: ${colors.colorGrey11}80;
  padding-left: 10px;
  min-width: 125px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.02px;
  color: ${colors.colorGrey14};

  font-family: inherit;

  :focus {
    outline: none !important;
  }

  @media (max-width: ${spaces.tabletBreakpoint}) {
    min-width: 100px;
    &::placeholder {
      color: transparent;
    }
  }
`

export default FilterInput
